import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { SetInitialStateFacade } from '../../../../../common/models';
import { UploadUserListData, UserListUploadInitialState } from './user-list-upload.actions';
import { UserListUploadState, UserListUploadStateModel } from './user-list-upload.state';

@Injectable({ providedIn: 'root' })
export class UserListUploadFacade implements SetInitialStateFacade {
  listDto$: Observable<UserListUploadStateModel> = this.store.select(UserListUploadState.getState);
  loaded$: Observable<boolean> = this.store.select(UserListUploadState.getLoaded);

  constructor(private store: Store) {}

  uploadUserData(language: string, userTimezone: string, userCountry: string, file: File): void {
    this.store.dispatch(new UploadUserListData({ language, userTimezone, userCountry, file }));
  }
  setInitialState(): void {
    this.store.dispatch(new UserListUploadInitialState());
  }
}
